import {
  brokerLabel,
  buyerLabel,
  deliveryLabel,
  packingLabel,
  paymentLabel,
  productSummary,
  qualityTypeLabel,
  quantityLabel,
  rateLabel,
  varietyLabel,
} from "../lib/salesContractOptions";

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const SALES_CONTRACT_COLUMNS = [
  { id: "contract_number", label: "Contract #", accessorKey: "contract_number", filterType: "text" },
  { id: "contract_date", label: "Date", accessorKey: "contract_date", filterType: "date" },
  { id: "buyer_name", label: "Buyer", accessor: buyerLabel, filterType: "text" },
  { id: "variety", label: "Variety", accessor: varietyLabel, filterType: "text" },
  {
    id: "quality_type",
    label: "Quality type",
    accessor: qualityTypeLabel,
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "STEAMED", label: "Steamed" },
      { value: "WHITE_SELLA", label: "White Sella" },
      { value: "GOLDEN_SELLA", label: "Golden Sella" },
    ],
    matchFilter: (row, value) => !value || row.quality_type === value,
  },
  { id: "quantity", label: "Qty (qtl)", accessor: quantityLabel, filterType: "text" },
  { id: "rate", label: "Rate", accessor: rateLabel, filterType: "text" },
  { id: "payment", label: "Payment", accessor: paymentLabel, filterType: "text" },
  { id: "broker_name", label: "Broker", accessor: brokerLabel, filterType: "text" },
  { id: "packing", label: "Packing", accessor: packingLabel, filterType: "text" },
  { id: "delivery", label: "Delivery", accessor: deliveryLabel, filterType: "text" },
  {
    id: "status",
    label: "Status",
    accessorKey: "status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "ACTIVE", label: "Active" },
      { value: "CLOSED", label: "Closed" },
    ],
    matchFilter: (row, value) => !value || row.status === value,
  },
];

export { productSummary };
